const o = (t) => {
  const r = t.trim().charAt(0);
  return r === "<" ? 1 : /\d/.test(r) ? 2 : r === ">" ? 3 : 4;
}, s = (t) => [...t].sort((r, e) => {
  const i = o(r), n = o(e);
  return i !== n ? i - n : r.localeCompare(e);
});
export {
  s as default
};
//# sourceMappingURL=sortNumericRange.js.map
